import React, { Component, Fragment } from 'react'
import { Link } from "react-router-dom";
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import { Container,Row,Col, Form,Button } from 'react-bootstrap'
import Product1 from '../../assets/images/networking.jpg'



class ComputerNetwork extends Component {
     render() {
          return (
               <Fragment>
                        
              <Container fluid={true}  className="BetweenTwoSection">
                <div className="breadbody">
               <Breadcrumb>
  <Breadcrumb.Item> <Link to="/"> Home </Link> </Breadcrumb.Item>
    <Breadcrumb.Item> <Link to=""> Service </Link> </Breadcrumb.Item>
  <Breadcrumb.Item> <Link to="/networking"> computer Network</Link> </Breadcrumb.Item>   
</Breadcrumb>
</div>
        <h2 className="section-title text-center mb-2 text-primary">COMPUTER NETWORKING</h2>

<p className="text-center mb-3"> Fast and reliable computer repair and maintenance services</p>
                   <Row className="">
<Col className="shadow-sm bg-white pb-3 mt-4" md={12} lg={12} sm={12} xs={12}>
     <Row>
          <Col className="p-3" md={6} lg={6} sm={12} xs={12}>
          <img  className="product-main"  src={Product1}  alt="ParkEase Dashboard"/>
          <Container  className="my-3">
              
               
          </Container>
          </Col>
          <Col className="p-3 " md={6} lg={6} sm={12} xs={12}>
            <h4></h4>
         
            <p>At ChrisAlpha Tech Company, we provide professional computer repair and maintenance services to keep your systems running smoothly. Our skilled technicians diagnose and fix hardware and software issues, remove viruses, upgrade systems, and perform routine maintenance to improve performance and reliability.
</p>
          <p>
With our expert networking services, you can enjoy faster communication, improved productivity, and secure access to your systems and data.
</p>
        
          <div className="">
           <ul>
  <li>Network design and installation</li>
  <li>LAN (Local Area Network) setup</li>
  <li>Wi-Fi installation and configuration</li>
  <li>Router and switch configuration</li>
  <li>Network troubleshooting and support</li>
  <li>Network security setup (firewalls and access control)</li>
  <li>Office and school network setup</li>
  <li>Structured cabling installation</li>
</ul>
         

          </div>
          </Col>
     </Row>

     <Row>
          <Col className="" md={6} lg={6} sm={12} xs={12}>
          <h6 className="mt-2"></h6>
          <h6>We specialize in designing, installing, and maintaining network systems that support your daily operations efficiently. Whether you need a new network setup, network expansion, or troubleshooting of connectivity issues, our experienced technicians deliver professional solutions tailored to your needs. 
            We focus on performance, security, and reliability to ensure your network runs seamlessly without interruptions.</h6>
           
        
          </Col>

          <Col className="" md={6} lg={6} sm={12} xs={12}>
          <h6 className="mt-2">REVIEWS</h6>
          <p className=" p-0 m-0"><span className="Review-Title"> Professional and Efficient Team</span><span className="text-success"> </span>    </p>
          <p>"The repair service was fast and affordable. They replaced my faulty hardware and upgraded my system. I am very satisfied with the results."</p>

          <p className=" p-0 m-0"><span className="Review-Title">Fast Response and Support</span> <span className="text-success"> </span> </p>
          <p>"Whenever we experience connectivity issues, their support team responds quickly and resolves the problem. We highly recommend their networking services."</p>

          </Col>
     </Row>
</Col>
                   </Row>
               </Container>
               
               </Fragment>
          )
     }
}

export default ComputerNetwork